<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">STATUS PROYEK</span>
                <span v-else>PROJECT STATUS</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Status Proyek</span>
                    <span v-else>Project</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h5 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        Tanggal Data: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                    </h5>
                    <h5 class="sub-title px-3 mb-0 labelpmis" v-else>
                        Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                    </h5>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-sm-12">
                <div class="card card-info card-tabs">
                    <div class="card-header p-0 pt-1">
                        <ul class="nav nav-tabs justify-content-center" id="custom-tabs-one-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="custom-tabs-one-home-tab" data-toggle="pill"
                                    href="#custom-tabs-one-home" role="tab" aria-controls="custom-tabs-one-home"
                                    aria-selected="true">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">MONITORING
                                        PROYEK</span>
                                    <span v-else>PROJECT MONITORING</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="custom-tabs-one-profile-tab" data-toggle="pill"
                                    href="#custom-tabs-one-profile" role="tab" aria-controls="custom-tabs-one-profile"
                                    aria-selected="false">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        MONITORING KOMPONEN DAN SUB KOMPONEN
                                    </span>
                                    <span v-else>
                                        COMPONENT AND SUB-COMPONENT MONITORING
                                    </span>
                                </a>
                            </li>
                            <li class="nav-item" style="display: none;">
                                <a class="nav-link" id="custom-tabs-one-messages-tab" data-toggle="pill"
                                    href="#custom-tabs-one-messages" role="tab" aria-controls="custom-tabs-one-messages"
                                    aria-selected="false">
                                    <span>OWP & AWP</span>
                                </a>
                            </li>
                            <li class="nav-item" style="display: none;">
                                <a class="nav-link" id="custom-tabs-one-settings-tab" data-toggle="pill"
                                    href="#custom-tabs-one-settings" role="tab" aria-controls="custom-tabs-one-settings"
                                    aria-selected="false">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        KEUANGAN
                                    </span>
                                    <span v-else>
                                        FINANCE
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body">
                        <div class="tab-content" id="custom-tabs-one-tabContent">
                            <div class="tab-pane fade show active" id="custom-tabs-one-home" role="tabpanel"
                                aria-labelledby="custom-tabs-one-home-tab">
                                <div class="card-body p-3">
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-4">
                                            <DonutsChartMonitoringWaktuProyek type="donut" :options="chartOptionswaktu"
                                                :series="serieswaktu" height="400">
                                            </DonutsChartMonitoringWaktuProyek>
                                        </div>
                                        <div class="col-sm-4">
                                            <DonutsChartMonitoringProyek type="donut" :options="chartOptionsproyek"
                                                :series="seriesproyek" height="400">
                                            </DonutsChartMonitoringProyek>
                                        </div>
                                        <div class="col-sm-4">
                                            <BarChartMonitoringPVProyekBaru type="bar" :options="chartOptionsbaru"
                                                :series="seriesbaru" height="400">
                                            </BarChartMonitoringPVProyekBaru>
                                        </div>
                                        <div class="col-sm-12 text-center">
                                            <div class="section-title mb-5" data-wow-delay="0.1s"
                                                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                                                <div class="sub-style">
                                                    <h5 class="sub-title px-3 mb-0 labelpmis"
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Monitoring Jumlah Paket
                                                    </h5>
                                                    <h5 class="sub-title px-3 mb-0 labelpmis" v-else>
                                                        Monitoring Number of Packages
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabel4('_Rekap_Kegiatan_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata4" style="font-size: smaller;">
                                                    <thead>
                                                        <th style="width: 50px;">No</th>
                                                        <th style="width: 150px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Paket
                                                            </span>
                                                            <span v-else>
                                                                Package
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">OWP (IDR)</th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Persiapan Pengadaan
                                                            </span>
                                                            <span v-else>
                                                                Procurement Preparation
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Lelang / Tahapan Pengadaan
                                                            </span>
                                                            <span v-else>
                                                                Tender / Procurement Stages
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Terkontrak / Pelaksanaan
                                                            </span>
                                                            <span v-else>
                                                                On Going
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Selesai
                                                            </span>
                                                            <span v-else>
                                                                Completed
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Total
                                                            </span>
                                                            <span v-else>
                                                                Total
                                                            </span>
                                                        </th>
                                                        <th style="width: 50px;">
                                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                Total terhadap OWP (%)
                                                            </span>
                                                            <span v-else>
                                                                Total to OWP (%)
                                                            </span>
                                                        </th>
                                                    </thead>
                                                    <template v-for="(datalist, urutlist) in dataresume"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-center">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td class="text-left">
                                                                    {{ datalist.JenisPekerjaan }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.OWP"
                                                                    data-z="#,##0.00">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datalistdetail, urutlistdetail) in datalist.detail"
                                                                    :key="urutlistdetail">
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.persiapan"
                                                                        data-z="#,##0">
                                                                        {{ G_numFormat(datalistdetail.persiapan) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.tender" data-z="#,##0">
                                                                        {{ G_numFormat(datalistdetail.tender) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.ongoing" data-z="#,##0">
                                                                        {{ G_numFormat(datalistdetail.ongoing) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.finish" data-z="#,##0">
                                                                        {{ G_numFormat(datalistdetail.finish) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-center" :data-v="datalist.jumlah"
                                                                    data-z="#,##0">
                                                                    {{ G_numFormat(datalist.jumlah) }}
                                                                </td>
                                                                <td class="text-center" :data-v="0" data-z="#,##0.00"
                                                                    v-if="totalowp == 0">
                                                                    0
                                                                </td>
                                                                <td class="text-center"
                                                                    :data-v="(datalist.OWP / totalowp) * 100"
                                                                    data-z="#,##0.00" v-else>
                                                                    {{ G_numFormatKoma((datalist.OWP / totalowp) * 100)
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <template v-for="(datalist, urutlist) in dataresumetotal"
                                                        :key="urutlist">
                                                        <tr>
                                                            <td class="text-center total" colspan="2">
                                                                TOTAL
                                                            </td>
                                                            <td class="totalkanan" :data-v="datalist.OWP"
                                                                data-z="#,##0">
                                                                {{ G_numFormat(datalist.OWP) }}
                                                            </td>
                                                            <template
                                                                v-for="(datalistdetail, urutlistdetail) in datalist.detail"
                                                                :key="urutlistdetail">
                                                                <td class="text-center total"
                                                                    :data-v="datalistdetail.persiapan" data-z="#,##0">
                                                                    {{ G_numFormat(datalistdetail.persiapan) }}
                                                                </td>
                                                                <td class="text-center total"
                                                                    :data-v="datalistdetail.tender" data-z="#,##0">
                                                                    {{ G_numFormat(datalistdetail.tender) }}
                                                                </td>
                                                                <td class="text-center total"
                                                                    :data-v="datalistdetail.ongoing" data-z="#,##0">
                                                                    {{ G_numFormat(datalistdetail.ongoing) }}
                                                                </td>
                                                                <td class="text-center total"
                                                                    :data-v="datalistdetail.finish" data-z="#,##0">
                                                                    {{ G_numFormat(datalistdetail.finish) }}
                                                                </td>
                                                            </template>
                                                            <td class="text-center total">
                                                                {{ G_numFormat(datalist.jumlah) }}
                                                            </td>
                                                            <td class="text-center total" :data-v="0" data-z="#,##0.00"
                                                                v-if="totalowp == 0">
                                                                0
                                                            </td>
                                                            <td class="text-center total"
                                                                :data-v="((datalist.OWP / totalowp) * 100)"
                                                                data-z="#,##0.00" v-else>
                                                                {{ G_numFormatKoma((datalist.OWP / totalowp) * 100) }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12 text-center wow fadeInUp" data-wow-delay="0.1s">
                                            <Bar1ChartMonitoringProyek type="bar" :options="chartOptionsbar1"
                                                :series="seriesbar1" height="350">
                                            </Bar1ChartMonitoringProyek>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12">
                                            <LineChartMonitoringProyek type="line" :options="chartOptionsmonitoring"
                                                :series="seriesmonitoring" height="500">
                                            </LineChartMonitoringProyek>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="custom-tabs-one-profile" role="tabpanel"
                                aria-labelledby="custom-tabs-one-profile-tab">
                                <div class="card-body p-3">
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabelKomponen('_Monitoring_Komponen_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>

                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata9"
                                                    style="font-size: 12px !important;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 250px;" rowspan="2">
                                                                Component
                                                            </th>
                                                            <th style="width: 250px;" rowspan="2">
                                                                Implementating Agencies
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                OWP
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                    Disbursement until {{
                                                                        G_formatDateNonWIB(tanggaldatamonev) }}
                                                                </span>
                                                                <span v-else>
                                                                    Disbursement until {{
                                                                        G_formatDateNonWIBEng(tanggaldatamonev) }}
                                                                </span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                % to OWP
                                                            </th>
                                                            <th style="width: 50px;" colspan="3">
                                                                Time Elapsed
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                Progress Variant
                                                            </th>
                                                            <th style="width: 150px;" rowspan="2">
                                                                Status
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th style="width: 50px;">
                                                                Duration (Month)
                                                            </th>
                                                            <th style="width: 50px;">
                                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                    Time Passed until {{
                                                                        G_formatDateNonWIB(tanggaldatamonev) }}
                                                                    (Month)
                                                                </span>
                                                                <span v-else>
                                                                    Time Passed until {{
                                                                        G_formatDateNonWIBEng(tanggaldatamonev) }}
                                                                    (Month)
                                                                </span>
                                                            </th>
                                                            <th style="width: 50px;">
                                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                                    Time Remaining (Month)
                                                                </span>
                                                                <span v-else>
                                                                    Time Remaining from (Month)
                                                                </span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(datalistproyek, urutproyek) in dataproyek"
                                                            :key="urutproyek">
                                                            <td class="text-left total" colspan="2">
                                                                TOTAL
                                                            </td>
                                                            <td class="text-right total">
                                                                {{ G_numFormat(datalistproyek.OWPTOTAL) }}
                                                            </td>
                                                            <td class="text-right total">
                                                                {{ G_numFormat(datalistproyek.Realisasi) }}
                                                            </td>
                                                            <td class="text-right total">
                                                                {{ G_numKoma(datalistproyek.persenkeowp) }}
                                                            </td>
                                                            <td class="text-center total">
                                                                {{ datalistproyek.WaktuLoanBulan }}
                                                            </td>
                                                            <td class="text-center total">
                                                                {{ G_numKoma(datalistproyek.ElapstimeusedBulan) }}
                                                            </td>
                                                            <td class="text-center total">
                                                                {{ G_numKoma(datalistproyek.WaktuLoanBulan -
                                                                    datalistproyek.ElapstimeusedBulan) }}
                                                            </td>
                                                            <td class="text-center total">
                                                                {{ G_numKoma(datalistproyek.PV) }}
                                                            </td>
                                                            <td class="text-center text-white"
                                                                :style="'background-color:' + datalistproyek.PVColor">
                                                                {{ datalistproyek.PVStatus }}
                                                            </td>
                                                        </template>
                                                        <template v-for="(datalist, urutlist) in datakomponen"
                                                            :key="urutlist">
                                                            <tr>
                                                                <td class="text-left levelkomponen">
                                                                    {{ datalist.nama }}. {{ datalist.keterangan }}
                                                                </td>
                                                                <td class="text-left levelkomponen">
                                                                    {{ datalist.PIUS }}
                                                                </td>
                                                                <td class="text-right levelkomponen">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <td class="text-right levelkomponen">
                                                                    {{ G_numFormat(datalist.REALISASI) }}
                                                                </td>
                                                                <td class="text-center levelkomponen">
                                                                    {{ G_numKoma(datalist.PERSEN) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datalistproyek, urutproyek) in dataproyek"
                                                                    :key="urutproyek">
                                                                    <td class="text-center levelkomponen">
                                                                        {{ datalistproyek.WaktuLoanBulan }}
                                                                    </td>
                                                                    <td class="text-center levelkomponen">
                                                                        {{ G_numKoma(datalistproyek.ElapstimeusedBulan)
                                                                        }}
                                                                    </td>
                                                                    <td class="text-center levelkomponen">
                                                                        {{ G_numKoma(datalistproyek.WaktuLoanBulan -
                                                                            datalistproyek.ElapstimeusedBulan) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-center levelkomponen">
                                                                    {{ G_numKoma(datalist.PV) }}
                                                                </td>
                                                                <td class="text-center text-white"
                                                                    :style="'background-color:' + datalist.WARNA">
                                                                    {{ datalist.STATUS }}
                                                                </td>
                                                            </tr>
                                                            <template
                                                                v-for="(datalistsub, urutlistsub) in datalist.subkomponen"
                                                                :key="urutlistsub">
                                                                <tr>
                                                                    <td class="text-left">
                                                                        {{ datalistsub.nama }}. {{
                                                                            datalistsub.keterangan }}
                                                                    </td>
                                                                    <td class="text-left">
                                                                        {{ datalistsub.PIUS }}
                                                                    </td>
                                                                    <td class="text-right">
                                                                        {{ G_numFormat(datalistsub.OWP) }}
                                                                    </td>
                                                                    <td class="text-right">
                                                                        {{ G_numFormat(datalistsub.REALISASI) }}
                                                                    </td>
                                                                    <td class="text-center">
                                                                        {{ G_numKoma(datalistsub.PERSEN) }}
                                                                    </td>
                                                                    <template
                                                                        v-for="(datalistproyek, urutproyek) in dataproyek"
                                                                        :key="urutproyek">
                                                                        <td class="text-center">
                                                                            {{ datalistproyek.WaktuLoanBulan }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{
                                                                                G_numKoma(datalistproyek.ElapstimeusedBulan)
                                                                            }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            {{ G_numKoma(datalistproyek.WaktuLoanBulan -
                                                                                datalistproyek.ElapstimeusedBulan) }}
                                                                        </td>
                                                                    </template>
                                                                    <td class="text-center">
                                                                        {{ G_numKoma(datalistsub.PV) }}
                                                                    </td>
                                                                    <td class="text-center text-white"
                                                                        :style="'background-color:' + datalistsub.WARNA">
                                                                        {{ datalistsub.STATUS }}
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <td colspan="3">Data masih kosong</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="custom-tabs-one-messages" role="tabpanel"
                                aria-labelledby="custom-tabs-one-messages-tab">
                                <div class="card-body p-3">
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabel2('_Rekap_OWP_AWP_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                        <div class="col-sm-12 text-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxOWPDetail" value="optionOWPDetail"
                                                    @click="showOWPDetail = !showOWPDetail" checked>
                                                <label for="customCheckboxOWPDetail" class="custom-control-label">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Show
                                                        Satker</span>
                                                    <span v-else>Show Satker</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata2"
                                                    style="font-size: 10px !important;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;" rowspan="2">
                                                                No
                                                            </th>
                                                            <th style="width: 250px;" rowspan="2">CPMU / NPIU / CPIU /
                                                                PIU</th>
                                                            <th style="width: 100px;" rowspan="2">OWP (IDR)</th>
                                                            <th style="width: 100px;" :colspan="datatahun.length">AWP
                                                                (IDR)</th>
                                                            <th style="width: 100px;" rowspan="2">Total<br>AWP<br>(IDR)
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Sisa<br>Pagu<br>(Rp.)</span>
                                                                <span v-else>Remaining<br>Ceiling<br>(IDR)</span>
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun" :data-v="listtahun.tahun"
                                                                data-z="#,##0" style="width: 50px;">
                                                                {{ listtahun.tahun }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="total" colspan="2"> TOTAL</td>
                                                            <td class="totalkanan" :data-v="totalowp" data-z="#,##0.00">
                                                                {{
                                                                    G_numFormat(totalowp)
                                                                }}
                                                            </td>
                                                            <td class="totalkanan"
                                                                v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun" data-z="#,##0">
                                                                {{ G_numFormat(listtahun.awppertahun) }}
                                                            </td>
                                                            <td class="totalkanan">
                                                                {{ G_numFormat(totalawp) }}
                                                            </td>
                                                            <td class="totalkanan">
                                                                {{ G_numFormat(sisapagu) }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <template v-for="(datalist, urutlist) in datamaster"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td data-z="#,##0"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td class="text-left"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ datalist.NmSatker }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.OWP"
                                                                    data-z="#,##0.00"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <td class="text-right"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']"
                                                                    v-for="(datalistawp, urutlistawp) in datalist.DetailAWP"
                                                                    :key="urutlistawp" :data-v="datalistawp.AWP"
                                                                    data-z="#,##0.00">
                                                                    {{ G_numFormat(datalistawp.AWP) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.TotalAWP"
                                                                    data-z="#,##0.00"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.TotalAWP) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.SisaPagu"
                                                                    data-z="#,##0.00"
                                                                    :class="[showOWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.SisaPagu) }}
                                                                </td>
                                                            </tr>
                                                            <tr v-for="(dataSatker, urutSatker) in datalist.Satker"
                                                                :key="urutSatker">
                                                                <td data-z="#,##0" v-if="showOWPDetail">
                                                                    {{ urutlist + 1 }}.{{ urutSatker + 1 }}
                                                                </td>
                                                                <td class="text-left" v-if="showOWPDetail">
                                                                    {{ dataSatker.nama_satker }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.OWP"
                                                                    data-z="#,##0.00" v-if="showOWPDetail">
                                                                    {{ G_numFormat(dataSatker.OWP) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datadetailSatker, urutdetailSatker) in dataSatker.detailsatker"
                                                                    :key="urutdetailSatker">
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.AWP" data-z="#,##0.00"
                                                                        v-if="showOWPDetail">
                                                                        {{ G_numFormat(datadetailSatker.AWP) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-right" :data-v="datalist.AWP"
                                                                    data-z="#,##0.00" v-if="showOWPDetail">
                                                                    {{ G_numFormat(dataSatker.AWP) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.SISAPAGU"
                                                                    data-z="#,##0.00" v-if="showOWPDetail">
                                                                    {{ G_numFormat(dataSatker.SISAPAGU) }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <td colspan="3">Data masih kosong</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="custom-tabs-one-settings" role="tabpanel"
                                aria-labelledby="custom-tabs-one-settings-tab">
                                <div class="card-body p-3">
                                    <div class="row g-4 justify-content-center">
                                        <div class="col-sm-12 text-center">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabel3('_Rekap_AWP_DIPA_REALISASI_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                        <div class="col-sm-12 text-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input custom-control-input-warning"
                                                    type="checkbox" id="customCheckboxAWPDetail" value="optionAWPDetail"
                                                    @click="showAWPDetail = !showAWPDetail" checked>
                                                <label for="customCheckboxAWPDetail" class="custom-control-label">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Show
                                                        Satker</span>
                                                    <span v-else>Show Satker</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata3"
                                                    style="font-size: 10px !important;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;" rowspan="2">No</th>
                                                            <th style="width: 100px;" rowspan="2">CPMU / NPIU / CPIU /
                                                                PIU</th>
                                                            <th style="width: 100px;" rowspan="2">OWP (IDR)</th>
                                                            <template v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun">
                                                                <th colspan="4" v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ listtahun.tahun }}
                                                                </th>
                                                            </template>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Total<br>Realisasi<br>(IDR)</span>
                                                                <span v-else>Total<br>Realization<br>(IDR)</span>
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Persentase<br>Realisasi<br>ke
                                                                    OWP<br></br>(%)</span>
                                                                <span v-else>Percentage of Realization<br>to
                                                                    OWP<br></br>(%)</span>
                                                            </th>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Kategori<br>Pencairan<br>Anggaran</span>
                                                                <span v-else>Disbursement<br>Category<br>Status</span>
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <template v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun">
                                                                <th style="width: 100px;"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    AWP (IDR)</th>
                                                                <th style="width: 100px;"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    DIPA (IDR)</th>
                                                                <th style="width: 100px;"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    <span
                                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi<br>(IDR)</span>
                                                                    <span v-else>Realization<br>(IDR)</span>
                                                                </th>
                                                                <th style="width: 10px;"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    <span
                                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Persentase<br>Realisasi<br>ke
                                                                        DIPA<br></br>(%)</span>
                                                                    <span v-else>Percentage<br>of Realization<br>to
                                                                        DIPA<br></br>(%)</span>
                                                                </th>
                                                            </template>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="total" colspan="2"> TOTAL</td>
                                                            <td class="totalkanan" :data-v="totalowp" data-z="#,##0.00">
                                                                {{
                                                                    G_numFormat(totalowp)
                                                                }}
                                                            </td>
                                                            <template v-for="(listtahun, uruttahun) in datatahun"
                                                                :key="uruttahun">
                                                                <td class="totalkanan" data-z="#,##0"
                                                                    :data-v="listtahun.awppertahun"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ G_numFormat(listtahun.awppertahun) }}
                                                                </td>
                                                                <td class="totalkanan" data-z="#,##0"
                                                                    :data-v="listtahun.dipa"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ G_numFormat(listtahun.dipa) }}
                                                                </td>
                                                                <td class="totalkanan" data-z="#,##0"
                                                                    :data-v="listtahun.realisasi"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ G_numFormat(listtahun.realisasi) }}
                                                                </td>
                                                                <td class="totalkanan" data-z="#,##0"
                                                                    :data-v="listtahun.persendipa"
                                                                    v-if="listtahun.tahun <= tahunsekarang">
                                                                    {{ G_numKoma(listtahun.persendipa) }}
                                                                </td>
                                                            </template>
                                                            <td class="totalkanan" :data-v="Realisasi"
                                                                data-z="#,##0.00">{{
                                                                    G_numFormat(Realisasi)
                                                                }}
                                                            </td>
                                                            <td class="totalkanan" :data-v="PersenOWP"
                                                                data-z="#,##0.00">{{
                                                                    G_numKoma(PersenOWP)
                                                                }}
                                                            </td>
                                                            <td :data-v="PVStatus"
                                                                :style="'background-color:' + ColorPVStatus">
                                                                {{ (PVStatus) }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <template v-for="(datalist, urutlist) in datamaster"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td data-z="#,##0"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td class="text-left"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ datalist.NmSatker }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.OWP"
                                                                    data-z="#,##0.00"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datalistawp, urutlistawp) in datalist.DetailAWP"
                                                                    :key="urutlistawp">
                                                                    <td class="text-right"
                                                                        :class="[showAWPDetail ? 'levelsubkomponen' : '']"
                                                                        :data-v="datalistawp.AWP"
                                                                        v-if="datalistawp.tahun <= tahunsekarang"
                                                                        data-z="#,##0.00">
                                                                        {{ G_numFormat(datalistawp.AWP) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :class="[showAWPDetail ? 'levelsubkomponen' : '']"
                                                                        :data-v="datalistawp.DIPA"
                                                                        v-if="datalistawp.tahun <= tahunsekarang"
                                                                        data-z="#,##0.00">
                                                                        {{ G_numFormat(datalistawp.DIPA) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :class="[showAWPDetail ? 'levelsubkomponen' : '']"
                                                                        :data-v="datalistawp.REALISASI"
                                                                        v-if="datalistawp.tahun <= tahunsekarang"
                                                                        data-z="#,##0.00">
                                                                        {{ G_numFormat(datalistawp.REALISASI) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :class="[showAWPDetail ? 'levelsubkomponen' : '']"
                                                                        :data-v="datalistawp.persendipa"
                                                                        v-if="datalistawp.tahun <= tahunsekarang"
                                                                        data-z="#,##0.00">
                                                                        {{ G_numKoma(datalistawp.persendipa) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-right" :data-v="datalist.realisasi"
                                                                    data-z="#,##0.00"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numFormat(datalist.realisasi) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.persenkeowp"
                                                                    data-z="#,##0.00"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ G_numKoma(datalist.persenkeowp) }}
                                                                </td>
                                                                <td class="text-center" :data-v="datalist.pv"
                                                                    :style="'background-color:' + datalist.warna"
                                                                    :class="[showAWPDetail ? 'levelsubkomponen' : '']">
                                                                    {{ datalist.pv }}
                                                                </td>
                                                            </tr>
                                                            <tr v-for="(dataSatker, urutSatker) in datalist.Satker"
                                                                :key="urutSatker">
                                                                <td data-z="#,##0" v-if="showAWPDetail">
                                                                    {{ urutlist + 1 }}.{{ urutSatker + 1 }}
                                                                </td>
                                                                <td class="text-left" v-if="showAWPDetail">
                                                                    {{ dataSatker.nama_satker }}
                                                                </td>
                                                                <td class="text-right" :data-v="dataSatker.OWP"
                                                                    data-z="#,##0.00" v-if="showAWPDetail">
                                                                    {{ G_numFormat(dataSatker.OWP) }}
                                                                </td>
                                                                <template
                                                                    v-for="(datadetailSatker, urutdetailSatker) in dataSatker.detailsatker"
                                                                    :key="urutdetailSatker">
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.AWP" data-z="#,##0.00"
                                                                        v-if="datadetailSatker.tahun <= tahunsekarang && showAWPDetail">
                                                                        {{ G_numFormat(datadetailSatker.AWP) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.DIPA"
                                                                        data-z="#,##0.00"
                                                                        v-if="datadetailSatker.tahun <= tahunsekarang && showAWPDetail">
                                                                        {{ G_numFormat(datadetailSatker.DIPA) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.REALISASI"
                                                                        data-z="#,##0.00"
                                                                        v-if="datadetailSatker.tahun <= tahunsekarang && showAWPDetail">
                                                                        {{ G_numFormat(datadetailSatker.REALISASI) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :data-v="datadetailSatker.PERSENDIPA"
                                                                        data-z="#,##0.00"
                                                                        v-if="datadetailSatker.tahun <= tahunsekarang && showAWPDetail">
                                                                        {{ G_numKoma(datadetailSatker.PERSENDIPA) }}
                                                                    </td>
                                                                </template>
                                                                <td class="text-right"
                                                                    :data-v="dataSatker.realisasitotal"
                                                                    data-z="#,##0.00" v-if="showAWPDetail">
                                                                    {{ G_numFormat(dataSatker.realisasitotal) }}
                                                                </td>
                                                                <td class="text-right"
                                                                    :data-v="dataSatker.persensatkerowp"
                                                                    data-z="#,##0.00" v-if="showAWPDetail">
                                                                    {{ G_numKoma(dataSatker.persensatkerowp) }}
                                                                </td>
                                                                <td class="text-center" :data-v="dataSatker.pv"
                                                                    :style="'background-color:' + dataSatker.warna"
                                                                    v-if="showAWPDetail">
                                                                    {{ dataSatker.pv }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <td colspan="3">Data masih kosong</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-4 justify-content-center">
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /.card -->
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "OpenSans-Regular, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts, BarChartMonitoringPVProyek: VueApexCharts
        , BarChartMonitoringPVProyekBaru: VueApexCharts, Bar1ChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            showOWPDetail: true,
            showAWPDetail: true,
            tahunsekarang: new Date().getFullYear(),
            datapesan: '',
            datamaster: [],
            datatahun: [],
            datakomponen: [],
            dataresume: [],
            dataresumetotal: [],
            totalowp: 0,
            totalawp: 0,
            sisapagu: 0,
            Realisasi: 0,
            PersenOWP: 0,
            PVStatus: '',
            ColorPVStatus: '',
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            project_id: process.env.VUE_APP_PROJECT_ID,
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),

            seriesbar1: [],
            chartOptionsbar1: {
                title: {
                    text: 'Jumlah Total Paket Dan Jenis Paket',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Kegiatan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Kegiatan"
                        }
                    }
                }
            },

            dataproyek: [],
            seriesproyek: [],
            chartOptionsproyek: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'OpenSans-Regular, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1000000000).toFixed(0).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' M';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1000000000000).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' T'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datawaktu: [],
            serieswaktu: [],
            chartOptionswaktu: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'OpenSans-Regular, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    formatter: function (value) {
                                        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                    },
                                },
                                value: {
                                    formatter: function (val) {
                                        return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan';
                                    }
                                },
                                total: {
                                    formatter: function (w) {
                                        let setTotal = w.globals.seriesTotals.reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
                                        let val = (setTotal / 1).toFixed(2).replace('.', ',')
                                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' Bulan'
                                    },
                                    show: true,
                                },
                            }
                        }
                    }
                },
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datapv: [],
            seriespv: [],
            chartOptionspv: {
                chart: {
                    type: 'donut',
                },

                tooltip: {
                    enabled: true,
                    formatter: function (value) {
                        return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    }
                },
                title: {
                    text: '',
                    align: 'center',
                    margin: 10,
                    offsetX: 0,
                    offsetY: 0,
                    floating: false,
                    style: {
                        fontSize: '14px',
                        fontWeight: 'bold',
                        fontFamily: 'OpenSans-Regular, Arial',
                        color: '#263238'
                    },
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ['#2176e6', '#ffc107'],
                labels: [],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },

            datamonitoring: [],
            seriesmonitoring: [],
            chartOptionsmonitoring: {
                chart: {
                    width: '100%',
                    height: 450,
                    type: 'line',
                    zoom: {
                        type: 'x',
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        autoSelected: 'zoom'
                    }
                },
                colors: ['#00CED1', '#FFD700', '#9370DB', '#4682B4', '#32CD32'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Average High & Low Temperature',
                    align: 'center'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: ''
                    }
                },
                yaxis: {
                    title: {
                        text: ''
                    },
                },
                legend: {
                    position: 'bottom',
                    floating: true,
                    offsetY: -10,
                    offsetX: -100,
                    show: true,
                }
            },

            series_newpv: [{
                data: []
            }],
            chartOptions_newpv: {
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        distributed: true,
                        horizontal: true,
                        dataLabels: {
                            position: 'bottom'
                        },
                    }
                },
                colors: [],
                dataLabels: {
                    enabled: true,
                    textAnchor: 'start',
                    style: {
                        colors: ['#fff']
                    },
                    formatter: function (val, opt) {
                        return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
                    },
                    offsetX: 0,
                    dropShadow: {
                        enabled: true
                    }
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: ['OCR', 'UK-ACGF TF', 'All'],
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                title: {
                    text: 'Progress Variant',
                    align: 'center',
                    floating: true
                },

                tooltip: {
                    theme: 'dark',
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                            formatter: function () {
                                return ''
                            }
                        }
                    }
                }
            },
            seriesbaru: [],
            chartOptionsbaru: {
                chart: {
                    height: 350,
                    type: 'line',
                    stacked: false,
                },
                annotations: {
                    yaxis: [{
                        y: 1,
                        strokeDashArray: 2,
                        width: '100%',
                        borderColor: '#90EE90',
                        label: {
                            borderColor: '#90EE90',
                            style: {
                                fontSize: '11px',
                                color: '#333',
                                background: '#90EE90',
                            },
                            text: 'ON SCHEDULE >=1',
                        },
                    }, {
                        y: 0.999,
                        strokeDashArray: 2,
                        width: '100%',
                        borderColor: '#90EE90',
                    }, {
                        y: 1.000,
                        strokeDashArray: 2,
                        width: '100%',
                        borderColor: '#90EE90',
                    }, {
                        y: 0.3,
                        strokeDashArray: 2,
                        borderColor: '#B22222',
                        label: {
                            borderColor: '#B22222',
                            style: {
                                fontSize: '11px',
                                color: '#ffffff',
                                background: '#B22222',
                            },
                            text: 'AT RISK <=0,3',
                        },
                    }, {
                        y: 0.2999,
                        strokeDashArray: 2,
                        borderColor: '#B22222',

                    }, {
                        y: 0.3,
                        strokeDashArray: 2,
                        borderColor: '#B22222',

                    }],
                },

                stroke: {
                    width: [5, 5, 5, 5, 5, 5],
                    curve: 'smooth'
                },
                plotOptions: {
                    bar: {
                        columnWidth: '50%'
                    }
                },
                fill: {
                    opacity: [1, 1, 1],
                    gradient: {
                        inverseColors: false,
                        shade: 'light',
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: ['PROGRESS VARIANT'],
                markers: {
                    size: 0
                },
                yaxis: {
                    title: {
                        text: 'PV',
                    },
                    min: 0,
                    max: 1.1,
                    forceNiceScale: false,
                },
                dataLabels: {
                    position: 'top',
                    style: {
                        colors: ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0) + " points";
                            }
                            return y;
                        }
                    }
                }
            },
        };
    },
    methods: {
        async G_tableCSVTabelKomponen(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakkomponen-Resume?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel2(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakresume-ResumeOWP?random=" + random + "&project_id=" + this.project_id + "&showsatker=" + this.showOWPDetail).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel3(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakresume-AWPDanKeu?random=" + random + "&project_id=" + this.project_id + "&showsatker=" + this.showAWPDetail).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel4(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetak-ResumeKegiatan?random=" + random + "&project_id=" + this.project_id).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-ProyekResume?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.dataproyek = [];
                        this.seriesproyek = [];

                        this.chartOptionsproyek = {
                            labels: []
                        };
                        this.dataproyek = Response.data.content.data;
                        this.tanggalsinkron = this.dataproyek[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = this.dataproyek[0].TanggalDataMonev;
                        this.datamaster = this.dataproyek[0].OWP;
                        this.datatahun = this.dataproyek[0].Tahun;
                        this.totalawp = this.dataproyek[0].AWPTOTAL;
                        this.sisapagu = this.dataproyek[0].SISAPAGUTOTAL;
                        this.Realisasi = this.dataproyek[0].Realisasi;
                        this.PersenOWP = this.dataproyek[0].persenkeowp;
                        this.PVStatus = this.dataproyek[0].PVStatus;
                        this.ColorPVStatus = this.dataproyek[0].PVColor;
                        this.totalowp = this.dataproyek[0].OWPTOTAL;
                        //alert(this.totalowp);
                        this.datawaktu = [];
                        this.serieswaktu = [];
                        this.chartOptionswaktu = {
                            labels: []
                        };
                        this.datawaktu = Response.data.content.data;
                        this.datapv = [];
                        this.seriespv = [];

                        this.chartOptionspv = {
                            labels: []
                        };
                        this.datapv = Response.data.content.data;
                        this.chartOptionspv.plotOptions = {
                            pie: {
                                donut: {
                                    labels: {
                                        show: true,
                                        name: {
                                            formatter: function (value) {
                                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            },
                                        },
                                        value: {
                                            formatter: function (val) {
                                                return (val / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                            }
                                        },
                                        total: {
                                            show: true,
                                            label: this.dataproyek[0].PVStatus,
                                            color: '#111',
                                            formatter: function (w) {
                                                return ''
                                            }
                                        }
                                    }
                                }
                            }
                        };
                        //alert(JSON.stringify(this.dataproyek));
                        this.seriesproyek.push(this.dataproyek[0].Realisasi);
                        this.seriesproyek.push(this.dataproyek[0].BelumRealisasi);

                        this.serieswaktu.push(this.datawaktu[0].ElapstimeusedBulan);
                        this.serieswaktu.push(this.datawaktu[0].WaktuLoanBulan - this.datawaktu[0].ElapstimeusedBulan);
                        var datapvnya = parseFloat(this.datapv[0].PV).toFixed(2);
                        var datakurangpvnya = parseFloat(this.datapv[0].PVRemaining).toFixed(2);
                        //alert(typeof parseFloat(datapvnya));
                        this.seriespv.push(parseFloat(datapvnya));
                        this.seriespv.push(parseFloat(datakurangpvnya));
                        //alert(this.seriespv);
                        this.chartOptionspv.colors = [this.datapv[0].PVColor, '#2176e6'];
                        var texttrilliyun = '';
                        var textrealisasi = '';
                        var textjudul = '';
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            texttrilliyun = 'Dalam Triliyun (Rp.)';
                            textrealisasi = 'Realisasi';
                            textjudul = 'Perbandingan OWP, AWP dan Realisasi Kumulatif Tahunan';
                            this.chartOptionsproyek.labels.push('Sudah dicairkan');
                            this.chartOptionsproyek.labels.push('Belum dicairkan');
                            this.chartOptionsproyek.title = {
                                text: 'Realisasi Pencairan Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'OpenSans-Regular, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionswaktu.labels.push('Waktu terpakai');
                            this.chartOptionswaktu.labels.push('Waktu tersisa');
                            this.chartOptionswaktu.title = {
                                text: 'Rasio Waktu Proyek',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'OpenSans-Regular, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionspv.labels.push('Progress Variant');
                            this.chartOptionspv.labels.push('Kekurangan ke ideal');
                            this.chartOptionspv.title = {
                                text: 'Progress Variant',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'OpenSans-Regular, Arial',
                                    color: '#263238'
                                },
                            };


                        }
                        else {
                            texttrilliyun = 'in Trilions (IDR)';
                            textrealisasi = 'Realization';
                            textjudul = 'Comparison of OWP, AWP and Annual Cumulative Realization';
                            this.chartOptionsproyek.labels.push('Disbursed');
                            this.chartOptionsproyek.labels.push('Undisbursed');
                            this.chartOptionsproyek.title = {
                                text: 'Realization of Project Disbursement',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'OpenSans-Regular, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionswaktu.labels.push('Elapse time');
                            this.chartOptionswaktu.labels.push('Time left');
                            this.chartOptionswaktu.title = {
                                text: 'Project Elapse Time Ratio',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'OpenSans-Regular, Arial',
                                    color: '#263238'
                                },
                            };

                            this.chartOptionspv.labels.push('Progress Variant');
                            this.chartOptionspv.labels.push('Deviciency to ideals');
                            this.chartOptionspv.title = {
                                text: 'Progress Variant',
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'OpenSans-Regular, Arial',
                                    color: '#263238'
                                },
                            };
                        }

                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.seriesbaru = [];
                        this.datamonitoring = Response.data.content.data;
                        var temptahun = [];
                        var tempowp = [];
                        var tempawp = [];
                        var tempspm = [];
                        var tempowpmonev = [];
                        var temprealisasimonev = [];
                        for (let i = 0; i < this.dataproyek[0].Tahun.length; i++) {
                            temptahun.push(this.dataproyek[0].Tahun[i].tahun);
                            tempowp.push(this.dataproyek[0].Tahun[i].owptrilyun);
                            tempawp.push(this.dataproyek[0].Tahun[i].awptrilyun);
                            tempspm.push(this.dataproyek[0].Tahun[i].spmtrilyun);
                            tempowpmonev.push(this.dataproyek[0].Tahun[i].dataowpmonevtrilyun);
                            temprealisasimonev.push(this.dataproyek[0].Tahun[i].datarealisasimonevtrilyun);
                        }

                        this.seriesmonitoring.push(
                            {
                                name: "OWP",
                                data: tempowp
                            },
                            {
                                name: "AWP",
                                data: tempawp
                            },
                            {
                                name: textrealisasi,
                                data: temprealisasimonev
                            }
                        )
                        this.seriesbaru = [{
                            name: 'NUFReP',
                            type: 'bar',
                            data: [this.dataproyek[0].PV.toFixed(2)],
                            color: this.dataproyek[0].PVColor
                        }];
                        //alert(temptahun);
                        this.chartOptionsmonitoring = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'OpenSans-Regular, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: temptahun,
                            },
                            yaxis: {
                                title: {
                                    text: texttrilliyun
                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 5,
                                offsetX: -10,
                                show: true,
                            }
                        };

                        this.series_newpv = [{
                            data: []
                        }];

                        this.series_newpv = [{
                            data: [parseFloat(this.datapv[0].PV).toFixed(2)]
                        }];

                        this.chartOptions_newpv = {
                            colors: [],
                            xaxis: {
                                categories: [],
                            },
                        }

                        this.chartOptions_newpv = {
                            colors: [this.datapv[0].PVColor],
                            xaxis: {
                                categories: ['NUFReP (' + this.datapv[0].PVStatus + ')'],
                            },
                        }

                        this.datakomponen = Response.data.content.komponen;
                        this.dataresumetotal = Response.data.content.resume;
                        this.dataresume = Response.data.content.resumedetail;
                        var jenispekerjaan = [];
                        var jumlahkegiatan = [];
                        var persiapan = [];
                        var pra_tender = [];
                        var tender = [];
                        var ongoing = [];
                        var finish = [];
                        var masterjenispekerjaan = Response.data.content.resumedetail;
                        for (let i = 0; i < masterjenispekerjaan.length; i++) {
                            this.halamanloading = true;
                            jenispekerjaan.push(masterjenispekerjaan[i].JenisPekerjaan);
                            jumlahkegiatan.push(masterjenispekerjaan[i].jumlah);
                            for (let c = 0; c < masterjenispekerjaan[i].detail.length; c++) {
                                persiapan.push(masterjenispekerjaan[i].detail[c].persiapan);
                                tender.push(masterjenispekerjaan[i].detail[c].tender);
                                ongoing.push(masterjenispekerjaan[i].detail[c].ongoing);
                                finish.push(masterjenispekerjaan[i].detail[c].finish);
                            }
                            this.halamanloading = false;
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.chartOptionsbar1 = {
                                title: {
                                    text: 'Jumlah Total Paket Dan Jenis Paket',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: jenispekerjaan,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Jumlah Paket'
                                    }
                                },
                            };
                        }
                        else {
                            this.chartOptionsbar1 = {
                                title: {
                                    text: 'Total Number of Packages and Package Type',
                                    align: 'center'
                                },
                                xaxis: {
                                    categories: jenispekerjaan,
                                },
                                yaxis: {
                                    title: {
                                        text: 'Number of Packages'
                                    }
                                },
                            };
                        }

                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            this.seriesbar1 = [{
                                name: 'Total Kegiatan',
                                data: jumlahkegiatan
                            }, {
                                name: 'Persiapan Pengadaan',
                                data: persiapan
                            }, {
                                name: 'Lelang / Tahapan Pengadaan',
                                data: tender
                            }, {
                                name: 'Terkontrak / Pelaksanaan',
                                data: ongoing
                            }, {
                                name: 'Selesai',
                                data: finish
                            }]
                        }
                        else {
                            this.seriesbar1 = [{
                                name: 'Total Activity',
                                data: jumlahkegiatan
                            }, {
                                name: 'Procurement Preparation',
                                data: persiapan
                            }, {
                                name: 'Tender / Procurement Stages',
                                data: tender
                            }, {
                                name: 'On Going',
                                data: ongoing
                            }, {
                                name: 'Completed',
                                data: finish
                            }]
                        }
                        //alert(JSON.stringify(this.chartOptionsmonitoring.xaxis));
                    }
                    else {
                        this.totalowp = 0;
                        this.datamonitoring = [];
                        this.seriesmonitoring = [];
                        this.datamaster = [];
                        this.dataproyek = [];
                        this.seriesproyek = [];
                        this.dataresume = [];
                        this.dataresumetotal = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionsproyek = {
                            labels: []
                        };

                        this.datawaktu = [];
                        this.serieswaktu = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionswaktu = {
                            labels: []
                        };

                        this.datapv = [];
                        this.seriespv = [];
                        this.tanggalsinkron = new Date();
                        this.chartOptionspv = {
                            labels: []
                        };
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.totalowp = 0;
                this.datamaster = [];
                this.datamonitoring = [];
                this.seriesmonitoring = [];
                this.dataresume = [];
                this.dataresumetotal = [];
                this.dataproyek = [];
                this.seriesproyek = [];
                this.tanggalsinkron = new Date();
                this.chartOptionsproyek = {
                    labels: []
                };

                this.datawaktu = [];
                this.serieswaktu = [];
                this.tanggalsinkron = new Date();
                this.chartOptionswaktu = {
                    labels: []
                };

                this.datapv = [];
                this.seriespv = [];
                this.tanggalsinkron = new Date();
                this.chartOptionspv = {
                    labels: []
                };
                //console.log(error);
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>